var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.361 7.929L13.611 13.9725C13.989 14.175 14.478 14.271 14.97 14.271C15.462 14.271 15.951 14.175 16.329 13.9725L27.579 7.929C28.3125 7.5345 29.0055 6 27.66 6H2.2815C0.936002 6 1.629 7.5345 2.361 7.929ZM27.9195 11.2335L16.329 17.274C15.819 17.541 15.462 17.5725 14.97 17.5725C14.478 17.5725 14.121 17.541 13.611 17.274C13.101 17.007 2.9115 11.6655 2.079 11.232C1.494 10.926 1.5 11.2845 1.5 11.5605V22.5C1.5 23.13 2.349 24 3 24H27C27.651 24 28.5 23.13 28.5 22.5V11.562C28.5 11.286 28.506 10.9275 27.9195 11.2335Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f11b599f55559ccf420ef1fc5fcf3037.svg";
export { ForwardRef as ReactComponent };